module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_3_4.53a0f186.png";